import { Controller } from '@hotwired/stimulus';
import {
  FORMULA_DELIMITER_CHANGED,
  getFormulaArgumentDelimiter,
  setFormulaArgumentDelimiter,
} from '../lib/generator_formula_delimiter';

export default class extends Controller {
  static targets = ['commaButton', 'semicolonButton'];

  connect() {
    this.syncUi(getFormulaArgumentDelimiter());
  }

  selectComma(event) {
    event.preventDefault();
    this.applyDelimiter('comma');
  }

  selectSemicolon(event) {
    event.preventDefault();
    this.applyDelimiter('semicolon');
  }

  applyDelimiter(value) {
    setFormulaArgumentDelimiter(value);
    this.syncUi(value);
    window.dispatchEvent(
      new CustomEvent(FORMULA_DELIMITER_CHANGED, { detail: { delimiter: value } })
    );
  }

  syncUi(value) {
    const comma = value === 'comma';
    if (this.hasCommaButtonTarget) {
      this.commaButtonTarget.setAttribute('aria-pressed', comma ? 'true' : 'false');
      this.commaButtonTarget.dataset.active = comma ? 'true' : 'false';
    }
    if (this.hasSemicolonButtonTarget) {
      this.semicolonButtonTarget.setAttribute('aria-pressed', comma ? 'false' : 'true');
      this.semicolonButtonTarget.dataset.active = comma ? 'false' : 'true';
    }
  }
}
